//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { sendCtmEvtLog } from '@/_base/log'

import HotSearch from '@/data/hot_search'
import Position from '@/data/position_log'

const DEFAULT_PLACEHOLDER = '按楼盘名字搜索'
export default {
    data() {
        return {
            tabs:[
                {
                    name:'VR找房',
                    url:'/pages/activity_a/vr/main',
                    class:'vr'
                },
                {
                    name:'地图找房',
                    url:'/pages/packageA/whole_buildings_map/main',
                    class:'map'
                },
                {
                    name:'航拍看房',
                    url:'/pages/activity_a/web_720/main',
                    class:'web720'
                },
                {
                    name:'直播看房',
                    url:'/pages/list/live/main',
                    class:'live'
                },
                {
                    name:'地铁找房',
                    url:'/pages/packageA/metro_list/main',
                    class:'metro'
                }
            ],
            hot_search: []
        }
    },
    props: {
        subject: {
            type: Object
        }
    },
    onReady () {
        this.remoteQuery()
    },
    methods: {
        goSearch() {
            wx.navigateTo({
                url: '/pages/index/search/main'
            })
        },
        goTab (e) {
            const { name, url } = e.currentTarget.dataset
            this.goUrl(url, name)
        },
        goSubject (item) {
            const { title, article_url } = item
            this.goUrl(article_url, title)
        },
        goUrl(url, name) {
            wx.navigateTo({
                url
            })
            sendCtmEvtLog(`找房-${name}点击`)
        },
        viewLog (i) {
            const item = this.hot_search[i]
            Position.log('hot_search_keyword', {
                id: item.id,
                pos: i,
                pos_name: item.position
            })
        },
        animationSwiper (e) {
            const { current } = e.target
            this.viewLog(current)
        },
        remoteQuery () {
            HotSearch.getKeyword().then(data => {
                if (data.length) {
                    this.hot_search = data.map((item) => {
                        const search_hot_keyword = item.content || item.target.name
                        return {
                            ...item,
                            search_hot_keyword: search_hot_keyword,
                            input_placeholder: search_hot_keyword ? `搜索：${search_hot_keyword}` :  DEFAULT_PLACEHOLDER
                        }
                    })
                }
            })
        },
        onClickHotSearch (i) {
            HotSearch.clickHotSearch(this.hot_search[i])
            this.goSearch()
        }
    }
}
